export default "__VITE_PUBLIC_ASSET__0f08f130__"